<template>
  <v-card max-width="344" outlined :loading="loading" elevation="2">
    <v-card-text v-if="!workspace">
      <p class="display-1 text--primary">Not Found</p>
      <p>If this persists please contact support</p>
    </v-card-text>
    <div v-else>
      <v-list-item three-line>
        <v-list-item-content>
          <div class="overline">Workspace</div>
          <v-list-item-title class="headline mb-1">
            {{
            workspace.State
            }}
          </v-list-item-title>
          <v-list-item-subtitle>Id: {{ workspace.WorkspaceId }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-avatar tile size="80" color="#ECEFF1">
          <v-icon
            v-if="
              workspace.State == 'PENDING' ||
                workspace.State == 'UPDATING' ||
                workspace.State == 'MAINTENANCE' ||
                workspace.State == 'REBOOTING' ||
                workspace.State == 'STARTING' ||
                workspace.State == 'REBUILDING'
            "
            x-large
            color="#F9A825"
          >mdi-progress-check</v-icon>
          <v-icon
            v-else-if="workspace.State == 'AVAILABLE'"
            x-large
            color="green"
          >mdi-check-circle-outline</v-icon>
          <v-icon v-else x-large color="red">mdi-progress-close</v-icon>
        </v-list-item-avatar>
      </v-list-item>
      <v-list dense>
        <v-list-item style="max-height: 10px">
          <v-list-item-subtitle>Compute type:</v-list-item-subtitle>
          <v-list-item-title class="text-right">{{ workspace.WorkspaceProperties.ComputeTypeName }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-subtitle>User Volume:</v-list-item-subtitle>
          <v-list-item-title class="text-right">
            {{
            workspace.WorkspaceProperties.UserVolumeSizeGib
            ? `${workspace.WorkspaceProperties.UserVolumeSizeGib} GB`
            : "N/A "
            }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-card>
</template>
<script>
import Authentication from "../auth";
import EventBus from "../utility/Eventbus";

export default {
  data() {
    return {
      workspace: undefined,
      loading: false,
      interval: undefined
    };
  },
  methods: {
    async fetchWorkspace() {
      this.loading = true;
      await this.setWorkSpace()
      this.loading = false;
    },
    async reFetchWorkspace() {
      if (this.isIdle) {
        return;
      }
      await this.setWorkSpace()
    },
    async setWorkSpace() {

      try {
      const isHEWorkspace = await this.$store.dispatch('isHEEnv');
      const workspaces = await Authentication.fetchGET('/api/ws/describe', { environment: isHEWorkspace ? 'PROD' : 'DEV'})
          if (workspaces && workspaces[0] && workspaces[0]) {
            this.workspace = workspaces[0];
          }
    
        } catch (error) {
          console.log(error)
      }

    }


  },
  async created() {
    this.fetchWorkspace();
    this.interval = window.setInterval(() => {
      this.reFetchWorkspace();
    }, 15000);
    EventBus.$on("idleVue_onActive", () => {
      this.fetchWorkspace();
    });
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    }
  }
};
</script>
